import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    background-color: #ffffff;
    color: #4F4C4C;
    line-height: 1.6;
  }

  h1, h2, h3 {
    font-family: 'Montserrat', sans-serif; /* Uma fonte mais moderna para títulos */
    font-weight: 700;
    margin-bottom: 1rem;
  }

  a {
    text-decoration: none;
    color: #c77408;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
`;

export default GlobalStyles;